import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

import { themeColors } from "letalkui"

const useStyles = makeStyles(({
	button: {
		...ColorUtil.getBackgroundAndContrastColor(themeColors.getPrimaryColor()),
		width: "300px",
		padding: "18px 40px",
		borderRadius: "50px"
	},
	new_module: {
		padding: "8px 12px",
		gap: "10px",
		...ColorUtil.getBackgroundAndContrastColor(themeColors.colors.tags.tag14),
		fontWeight: 600,
		fontSize: "14px"
	},
	logo: {
		display: "block",
		margin: "0 auto",
		maxWidth: "120px",
		height: "auto"
	}
}))

export default useStyles
